export function moneyStringToCents(moneyString: string) {
  // Step 1: Parse the money string into a floating-point number
  const parsedValue = parseFloat(moneyString.replace(/[^0-9.-]/g, "")); // Remove non-numeric characters

  // Check if the parsing was successful
  if (isNaN(parsedValue)) {
    throw new Error("Invalid money string");
  }

  // Step 2: Convert to cents and round to the nearest integer
  const cents = Math.round(parsedValue * 100);

  // Step 4: Store as an integer representing cents
  return cents;
}
